import styled from "@emotion/styled";
import React from "react";
import DashboardDataTile from "../DashboardDataTile/DashboardDataTile";
import ReservedTimeSummaryTile from "../ReservedTimeSummaryTile/ReservedTimeSummaryTile";
import { TMeetingOverviewDashBoard } from "types/analytics.types";
import { useRecoilValue } from "recoil";
import { workspace } from "recoil/recoilState";

type DashboardDataTileListProps = {
  data?: TMeetingOverviewDashBoard; // Adjust type as necessary based on your data structure
  disabled?: boolean; // Optional prop to disable the tiles
};
const DashboardDataTileList: React.FC<DashboardDataTileListProps> = ({ data, disabled }) => {
  const workspaceInfo = useRecoilValue(workspace);
  const showEnabledWorkspaceName = ["토스증권", "토스코어", "마일코퍼레이션"];

  return (
    <Container className="dashboard-data-tile-list">
      <FirstRowContainer>
        <div style={{ display: "flex", minWidth: 620, gap: 20, width: "100%", height: "100%" }}>
          <DashboardDataTile
            label="총 회의실 예약 수"
            value={(data?.totalMeetingCount?.toLocaleString() || "0") + "개"}
            tooltip="조회 기간 동안 예약된 총 회의실 예약 수입니다."
          />
          <DashboardDataTile
            label="총 회의실 사용 시간"
            value={(data?.totalMeetingTime?.toLocaleString() || "0") + "시간"}
            tooltip="조회 기간 동안 총 회의실 사용 시간입니다."
          />
          <DashboardDataTile
            label="노쇼 비율"
            value={(data?.noShowRate?.toFixed(0) || "0") + "%"}
            tooltip="조회 기간 내 총 회의실 예약 수 대비 노쇼 비율입니다."
          />
        </div>
        <div style={{ display: "flex", minWidth: 460, gap: 20, width: "100%" }}>
          <DashboardDataTile
            disabled={disabled}
            label="가장 많이 사용된 회의실"
            value={data?.maxUsageMeetingRoomName || "-"}
            subValue={(data?.maxUsageMeetingTime || 0) + "시간"}
            tooltip="조회 기간 동안 가장 많은 시간 점유된 회의실입니다."
          />
          <DashboardDataTile
            disabled={disabled}
            label="가장 적게 사용된 회의실"
            value={data?.minUsageMeetingRoomName || "-"}
            subValue={(data?.minUsageMeetingTime || 0) + "시간"}
            tooltip="조회 기간 동안 가장 적은 시간 점유된 회의실입니다."
          />
        </div>
      </FirstRowContainer>
      <ReservedTimeSummaryTile data={data} disabled={disabled} />
      {data?.recycleTime && showEnabledWorkspaceName.some((item) => workspaceInfo?.name === item) && (
        <DashboardDataTile
          disabled={disabled}
          width="320px"
          label="재사용된 시간 / 재사용 가능 시간"
          value={`${data?.recycleTime.recycleTime.toLocaleString() || "0"}시간 / ${data?.recycleTime.recyclableTime.toLocaleString() || "0"}시간`}
          tooltip={
            <p>
              재사용 가능 시간은 Mile 기능을 통해 확보한 여유 시간 중 조회 기간 내에 재사용할 수 있는 시간을 의미하며,
              <br />
              재사용된 시간은 재사용 가능 시간 중 실제로 회의실이 재예약되어 사용된 시간을 의미합니다.
            </p>
          }
        />
      )}
    </Container>
  );
};

export default React.memo(DashboardDataTileList);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
`;

const FirstRowContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
`;
